/*
 * Copyright (c) 2015 - 2022 by KAA Soft. All rights reserved.
 */

import './lang';
import './adminConfig';
// import './utils';
import './domReady';

// import './page-components/page-forms'
// import './page-components/page-form-components'
// import './page-components/page-modals'
// import './page-components/page-listing'
// import './pages/page-posts' // ok
// import './pages/page-save-form' // ok
// import './pages/page-menus'
// import './pages/page-client-messages'